import React from 'react';
import classnames from 'classnames';
import Form, { FormFooter } from '@atlaskit/form';
import Button, { LoadingButton } from '@atlaskit/button';

interface Props {
  className?: string;
  onSubmit: (formData: any) => Promise<void> | void;
  onCancel: () => void;
  isValid: boolean;
  children: React.ReactNode;
}

export const ApplyPromoCodeForm = ({ className, children, onCancel, onSubmit, isValid }: Props) => {
  return (
    <div className={classnames('pv-8 ph-8', className)} data-testid="add-promocode-form">
      <Form onSubmit={onSubmit}>
        {({ formProps }) => (
          <form {...formProps}>
            <div>
              {children}
              <FormFooter align="end">
                <Button onClick={onCancel} className="mr-8" data-testId="cancel-promocode-form">
                  Cancel
                </Button>
                <Button appearance="primary" type="submit" isDisabled={!isValid} data-testId="submit-promocode-form">
                  Apply
                </Button>
              </FormFooter>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
};
